import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NewsService } from '../../services/NewsService';
import { ResourceService } from '../../services/ResourceService';
import { DealService } from '../../services/DealService';

@Injectable({
  providedIn: 'root'
})
export class ResourceCenterResolverService implements Resolve<any>{

    constructor(private resourceservice: ResourceService) { }

    resolve(route: ActivatedRouteSnapshot) {    
        return this.resourceservice.getAllResourceCategories();
    }
};

@Injectable({
  providedIn: 'root'
})
export class ResourceListResolverService implements Resolve<any>{

  constructor(private resourceservice: ResourceService) { }

  resolve(route: ActivatedRouteSnapshot) {    
      let categoryId = route.paramMap.get('categoryid');
      return this.resourceservice.getResourcesByCategoryId(categoryId);
  }
};

@Injectable({
  providedIn: 'root'
})
export class ResourceSearchResolverService implements Resolve<any>{

  constructor(private resourceservice: ResourceService) { }

  resolve(route: ActivatedRouteSnapshot) {    
    let searchterm = route.paramMap.get('searchterm');
    return this.resourceservice.searchResources(searchterm);
  }
};

@Injectable({
  providedIn: 'root'
})
export class ResourceGetResolverService implements Resolve<any>{

  constructor(private resourceservice: ResourceService) { }

  resolve(route: ActivatedRouteSnapshot) {    
    let id = route.paramMap.get('id');
    return this.resourceservice.getResourceById(id);
  }
};